import apiClient from "./apiClient";
import { PbiLink } from "../types/pbiLinkTypes";

export const getPbiLinks = async (): Promise<PbiLink[]> => {
  const response = await apiClient.get(`/pbi-links`);
  return await response.data;
};

export const getPbiLinksByProjectId = async (projectId: number): Promise<PbiLink[]> => {
  const response = await apiClient.get(`/pbi-links/project/${projectId}`);
  return await response.data;
};

export const createPbiLink = async (pbiLink: PbiLink): Promise<PbiLink> => {
  const response = await apiClient.post(`/pbi-links`, pbiLink);
  return await response.data;
};

export const updatePbiLink = async (pbiLinkId: number, pbiLink: PbiLink): Promise<PbiLink> => {
  const response = await apiClient.put(`/pbi-links/${pbiLinkId}`, pbiLink);
  return await response.data;
};

export const deletePbiLink = async (pbiLinkId: number): Promise<void> => {
  await apiClient.delete(`/pbi-links/${pbiLinkId}`);
};